let $ = require( "jquery" );

$(function() {
    var announce_height = $('#shopify-section-announcement-bar').height();
    $('div.mobile-menu').css('top',announce_height);

    $('body').on('click','.slideshow__slide',function(){
        var url = $(this).next('a.full-banner-link').attr('href');
        $(this).next('a.full-banner-link').trigger('click');
        window.location.href = url;
    })
	// focus into svg path/use is a thing for some reason
	$('svg *').attr('tabindex', -1);

    let mobileNavToggle = $('#mobile-navigation-toggle'),
        mobileNav = $('#mobile-navigation'),
        onlyMegamenu = $('.only-megamenu .has_click'),
        hasSubmenu = $('.has-submenu .has_click'),
        mobileColumnToggles = $('.tavi-menu .lastmenu'),
        closeButton = $('.close-menu'),
        backButton = $('button.mobile_backButton');

    mobileNavToggle.on('click', function() {
        if($('body').hasClass('styles-vooray')){
          mobileNav.slideToggle();
        }else{
          mobileNav.toggleClass('menu-open')
        }
		$('body').toggleClass('menu-shown');
    });

    closeButton.on('click',function(){
        $('body').removeClass('menu-shown');
        $('#mobile-navigation').removeClass('menu-open');
        $('.column ul:not(\'.discover-submenu\')').hide();
        $('.mobile-toggle').removeClass('is-open');
        $('.megamenu').removeClass('submenu-open');
        $('.main_menu').removeClass('innermenu-open');
        $('.megamenu .submenu').hide();
        $('.column-heading-link').removeClass('is_active');
        $('.has_click').removeClass('is_active');
        $('.main_menu li').removeClass('hide')
    })

    onlyMegamenu.on('click',function(e){
        let submenu = $(this).siblings('.submenu'),
            otherSubMenus = $(this).parent('a').parent('li').parent('ul').find('.submenu').not(submenu),
            otherMenus = $(this).parents('li.tavi-menu').siblings('li');
        if($(window).width() <= 768 && submenu.length) {
            $(this).toggleClass('is_active');
            e.preventDefault();
            e.stopPropagation();
            // otherMenus.toggleClass('hide');
            otherMenus.removeClass('is_active');

            $(this).find('.mobile-toggle').toggleClass('is-open');
            submenu.slideToggle();
            otherSubMenus.parent().find('a .mobile-toggle').removeClass('is-open');
            otherSubMenus.slideUp();
        }

    })
    hasSubmenu.on('click',function(e){
        e.preventDefault();        
        let submenu = $(this).siblings('.submenu'),
        otherMenu = $(this).parents('li').siblings('li.only-megamenu').find('a.has_click'),
        otherSubmenu = $(this).parents('li').siblings('li.only-megamenu').find('.submenu');
        submenu.addClass('submenu-open'); 
        $('.main_menu').addClass('innermenu-open'); 
        otherMenu.removeClass('is_active');
        otherSubmenu.hide();  

    })
    backButton.on('click',function(){
        let parent_menu = $(this).parents('.submenu');
        parent_menu.removeClass('submenu-open');
        $('.main_menu').removeClass('innermenu-open');
        $('.column ul:not(\'.discover-submenu\')').hide();
        $('.mobile-toggle').removeClass('is-open');
        $('.only-megamenu .lastmenu').removeClass('is_active');
    })

    $('a').on('click', function (e) {
        let href = $(this).attr('href');
        if(href === '#') {
            if($(this).find('.mobile-toggle').length) {
                e.preventDefault();
                $(this).find('.mobile-toggle').trigger('click');
            }
        }
    })

    mobileColumnToggles.on('click', function (e) {

        let column = $(this).siblings('ul.has-heading'),
            otherColumns = $('ul.has-heading:not(\'.discover-submenu\')').not(column),
            otherMenu = $(this).parents('.column').siblings('.column').find('a.column-heading-link');
            $(this).toggleClass('is_active')

        if($(window).width() <= 768 && column.length) {
            e.preventDefault();
            e.stopPropagation();
            // otherMenu.removeClass('is_active')

            $(this).find('.mobile-toggle').toggleClass('is-open');
            column.slideToggle();
            // otherColumns.siblings('.column-heading-link').find('.mobile-toggle').removeClass('is-open');
            // otherColumns.slideUp();
        }

    });

    if(getQueryParams(window.location.href).site === 'toesox') {
        $('body').removeClass('styles-tavi');
        $('.homepage-tavi').addClass('hide');
        $('.homepage-toesox').removeClass('hide');
    }

    /* Klaviyo forms listener from headless theme */
    window.addEventListener('klaviyoForms', function(e) {
        window.dataLayer = window.dataLayer || [];
        window.dataLayer.push({
            event: 'sign_up',
            detail: {
                id: e.detail.formId,
                type: e.detail.type,
                source: e.detail.metaData ? e.detail.metaData[`$source`] : ''
            }
        });
    });

    $('#search-open').on('click', function (e) {
        e.preventDefault();
        $('body').addClass('search-open');
        $('#Search-header').select();
        $(this).attr('aria-expanded', true);
		window.helpers.triggerEl = $(this);
		window.helpers.trapFocus('#site-search', false);
    });
    $('body').on('click', '#search-close', function (e) {
        e.preventDefault();
        $('body').removeClass('search-open');
        $('#search-open').attr('aria-expanded', false);
		window.helpers.returnFocus();
    });

	$('body').on('keyup', function (e) {
        if (window.helpers.isEscape(e)) {
            $('body').removeClass('search-open');
        	$('#search-open').attr('aria-expanded', false);
			window.helpers.returnFocus();
        }
    });

	$('a.level-1-item').on('click', function(e){
        if($(window).width() < 769){
          e.preventDefault();
		  $(this).closest('li').toggleClass('active');
        }
	});

	$('.site-menu li.has-children').hover(function(){
		$('body').addClass('submenu-open');
	}, function(){
		$('body').removeClass('submenu-open');
	});
    $('body').on('mouseover','.main_menu li.megamenu , .main_menu li.megamenu .submenu',function(event){
        $('body').addClass('nav--open')
        if(!$(this).hasClass('megamenu')){
            $('body').removeClass('nav--open')
        }
    });
    $('body').on('mouseleave','.main_menu li.megamenu , .main_menu li.megamenu .submenu',function(event){
        $('body').removeClass('nav--open')
    });
});

function getQueryParams(url) {
    const paramArr = url.slice(url.indexOf('?') + 1).split('&');
    const params = {};
    paramArr.map(param => {
        const [key, val] = param.split('=');
        params[key] = decodeURIComponent(val);
    })
    return params;
}

function closeSearch(){

}


